/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import authService from "../../../../../components/api-authorization/AuthorizeService";
import FooterSection from "trade-customer-portal/views/footer.js";
import HeaderSection from "trade-customer-portal/views/header.js";
import { Redirect } from "react-router-dom"; //import Redirect first
import PaymentInput from "./Classes/InputPaymentDetails.js";
import { Paper, Box, Stepper, Step, StepLabel } from "@material-ui/core";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe, useElements } from "@stripe/react-stripe-js";
import LoadingData from "../../../lottieLoading.js";

// styling
import style from "../../../../../assets/jss/CustomerTradePortal/views/OrderProcessPageSections/orderProcessStageThreePageStyle.js";
import StepperView from "../../../Common/stepperPage.js";
import { useDispatch, useSelector } from "react-redux";
const useStyles = makeStyles(style);

//DEV
//const stripePromise = loadStripe(
//    "pk_test_51Rt4QmB8Pd0fCBmSLPqgQYV2BOsvCtdCwTpcBXudpWbSLVX8Er0d59aK6OdRY2SpmT5Ce1Lli6oVWdEaZpjGG3Cl006RO0zJ59"
//);

//LIVE
const stripePromise = loadStripe(
    "pk_live_51Rt4QdBkvzLbXUe8ccYNTMyRYDiKbpu7JSCvpAp1cNgf8nqqOQUg9lvZEzwTUzRZlJy8WvaSjem2c2fCBNJXCL5K00ZVW3QZjH"
);

function StripeGate({ loading, children }) {
    const stripe = useStripe();
    const elements = useElements();

    if (!stripe || !elements || loading) {
        return <LoadingData text={"Please Wait...."} />;
    }
    return children;
}

// Landing Page for customer trade portal
export default function OrderPaymentPage() {

    // Redux state
    let forceUserBack = useSelector((state) => state.orderReducer.forceUserBack);
    const {
        orderSummaryResult,
    } = useSelector((state) => ({
        orderSummaryResult: state.orderReducer.orderSummaryResult,
    }));

    // useEffect
    const [loading, setLoading] = React.useState(true);
    const [clientSecret, setClientSecret] = React.useState(null);
    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        getPaymentIntent();
    }, []);

    const getPaymentIntent = async () => {
        setLoading(true);
        const token = await authService.getAccessToken();
        const response = await fetch("api/orderprocess/createPaymentIntent", {
            method: "post",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                amountInDecimal: parseFloat(orderSummaryResult.total_Price_Inc_VAT),
            })
        }).then((res) => res.json());
        setClientSecret(response.clientSecret);
        setLoading(false);
    }

    const classes = useStyles();

    const options = {
        mode: 'payment',
        amount: Math.round(orderSummaryResult.total_Price_Inc_VAT * 100),
        currency: "gbp",
    }

    const elementsOptions = React.useMemo(() => ({
      //  mode: 'payment',
      //   amount: Math.round(orderSummaryResult.total_Price_Inc_VAT * 100),
      //   currency: "gbp",
        clientSecret: clientSecret
    }
      ), [clientSecret]);

    //Return Data

    if (forceUserBack === true) {
        return <Redirect to="/OrderForm" />;
    }

  return (
    !clientSecret ? <LoadingData text={"Please Wait...."} />: (
    <Elements stripe={stripePromise} options={elementsOptions}>
      <StripeGate loading={loading}>
        <div>
          <HeaderSection />
          <div
            className={classNames(
              classes.main,
              classes.mainRaised,
              classes.mainSection,
              classes.sidePageMainSection
            )}
          >
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem
                  md={7}
                  sm={8}
                  className={classNames(
                    classes.mlAuto,
                    classes.mrAuto,
                    classes.textCenter
                  )}
                >
                  <h1 className={classes.title1} style={{ color: "black" }}>
                    Order Payment
                  </h1>
                </GridItem>
                <GridItem
                  md={7}
                  sm={8}
                  className={classNames(classes.mlAuto, classes.mrAuto)}
                >
                  <div className={classes.sidePageBorderLine} />
                </GridItem>
              </GridContainer>
              <StepperView stepValue={2} />
              <PaymentInput clientSecret={clientSecret} />
            </div>
          </div>
          <FooterSection />
        </div>
      </StripeGate>
    </Elements>
    ) 
  );

}
